/* eslint-disable react/prop-types, react/jsx-filename-extension */
import React from 'react';

import Date from '../../../common/date';
import Money from '../../../common/money';
import ImpersonateUser from '../../shared/ImpersonateUser';

export default [
  {
    Header: 'Name',
    accessor: 'name',
    id: 'name',
  },
  {
    Header: 'Last transfer amount',
    accessor: 'lastTransferAmount',
    id: 'lastTransferAmount',
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: 'Last transfer date',
    accessor: 'lastTransferDate',
    id: 'lastTransferDate',
    Cell: props => <Date date={props.value} timezone={props.original.timezone} />,
  },
  {
    Header: 'Accumulated balance',
    accessor: 'accumulatedBalance',
    id: 'accumulatedBalance',
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: 'Actions',
    accessor: 'userId',
    Cell: props => <ImpersonateUser id={props.value} />,
  },
];
